import {getClientCity} from 'ultra/configs/general';
import {DEFAULT_CITY} from 'ultra/const/general';

import Button from '@mui/material/Button';
import TelegramIcon from '@mui/icons-material/Telegram';

import {useNavigationStore} from '../../../../../../../../Stores/navigation';

import FormContainer from "../../../../../../../../Components/Form/FormContainer";

import CKEditorContent from '../../../../../../Widgets/CKEditorContent'
import TopPagePicture from '../../../../../../Widgets/TopPagePicture'
import TitleWidget from '../../../../../../Widgets/Title'
import BreadcrumbsWidget from '../../../../../../Widgets/Breadcrumbs'
import Gallery from '../../../../../../Widgets/Gallery';

import {getTelegramUserId} from '../../../../../../../../Helpers/telegram';

import './index.scss'

export default function Template(props) {
    const {content, permits, config, breadcrumbs} = props
  
    const {contentLoading} = useNavigationStore()

    const city = getClientCity(window) || DEFAULT_CITY;
    const command = `goToDid---${city}___${content._did}`;
    const tgLink = `https://t.me/${'MiyProstirBot'}/${city}?startapp=${command}`;

    console.log(getTelegramUserId())

    return <div className="FormTemplate">
        {content.banner && <TopPagePicture showSkeleton={contentLoading} cutHeightForDesktop image={content.banner} hidden={config?.templateOptions?.topPagePictureHidden}/>}

        <TitleWidget permits={permits} content={content} config={config} breadcrumbs={breadcrumbs} hide={content.hideTitle} />
        <BreadcrumbsWidget links={breadcrumbs} hide={content.hideBreadcrumbs}/>

        {config?.templateOptions?.descriptionPosition === 'top' && <>
          <CKEditorContent showSkeleton={contentLoading} content={content.description} />
          {content.gallery && <Gallery content={content.gallery} />}
        </>}

        <div className="form">
          {(!content?.form?.tgOnlyText || (content?.form?.tgOnlyText && getTelegramUserId())) && <FormContainer id="form-node-${path}" showSkeleton={contentLoading} config={content} />}
          {content?.form?.tgOnlyText && !getTelegramUserId() && <div>
            <div style={{marginBottom: "1rem"}}><b>{content?.form?.tgOnlyText}</b></div>
            <div><Button startIcon={<TelegramIcon />} fullWidth variant='outlined' href={tgLink}>Перейти в бот</Button></div>
          </div>}
        </div>

        {config?.templateOptions?.descriptionPosition !== 'top' && 
          <>
            <CKEditorContent showSkeleton={contentLoading} content={content.description} />
            {content.gallery && <Gallery content={content.gallery} />}
          </>
        }
    </div>
}
